import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { closePopup } from '../../actions/uiActions'

function ViewDbJobLog(props) {
    const [entries, setEntries] = useState([])

    // trigger on component mount
    useEffect(() => {
        // split on pipes and line breaks; the + treats \r\n as one break and collapses runs of separators
        let splitEntries = props.popupInfo.historyData.jobLog.split(/[|\r\n]+/)
        setEntries(splitEntries)
    }, [])

    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }

    // This is the render logic, no need to declare another method is a functional component
    return (<Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={true}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <CloseIcon onClick={handleClick} className="closePoup" />
        <DialogTitle id="alert-dialog-title" className="changepassdialog">
            {'Job Log'}
            {' '}
        </DialogTitle>
        <DialogContent>
            <div className="dbjoblog">
                { entries.map((x, i) => <p key={`log-${i}`}>{x}</p>) }
            </div>
        </DialogContent>
    </Dialog>)
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewDbJobLog)